import { Trans, useLingui } from '@lingui/react';
import { NumberFormat } from '@startuptools/ui/NumberFormat';
import { BigNumber } from 'bignumber.js';

export const SplitLabel = ({ before, after, loading }: { before: string; after: string; loading?: boolean }) => {
  const { i18n } = useLingui();
  const beforeNumber = new BigNumber(before);
  const afterNumber = new BigNumber(after);
  return (
    <Trans
      id="Which results in a {splitFactor} {label}"
      values={{
        label: afterNumber.gte(beforeNumber) ? <Trans id="split" /> : <Trans id="reverse split" />,
        splitFactor: !loading ? (
          <>
            {afterNumber.lt(beforeNumber) && '1:'}
            <NumberFormat locale={i18n.locale} minimumFractionDigits={0}>
              {afterNumber.gte(beforeNumber) ? new BigNumber(after).div(before) : new BigNumber(before).div(after)}
            </NumberFormat>
            {afterNumber.gte(beforeNumber) && ':1'}
          </>
        ) : (
          '...'
        ),
      }}
    />
  );
};
